import React, { Component } from "react";
import { apiCall_domain, token } from "../api";
import axios from "axios";
import ProductsInfo from "./ProductInfo";
import Vendors from "./vendors";
import Spinner from "../Spinner/Spinner";
import CommentProduct from "./CommentProduct";
import PicturesTab from "./PicturesTab";
import { createGlobalStyle } from "styled-components";
import TotalDescription from "../PopUps/TotalDescription";
import RelatedPosts from "./RelatedPosts";
import SimilarProducts from "./SimilarProducts";
import { Product } from "../../Contexts/Contexts";
import { Link } from "react-router-dom";
import OtherVendors from "./OtherVendors";
import Service from "./AddToCart/Service";
import Header from "../header";
import CommentView from "./CommentView";
import SuitableCars from "./SuitableCars";
import AddTicket from "./AddTicket";

class Products extends Component {
  state = {
    data: {},
    loading: true,
    selectedVendor: {},
    shoppingCart: [],
    shopItem: null,
    showImageGallery: false,
    addedToCart: false,
    showVendorList: false,
    showAddToCartModal: false,
    isFavorite: false,
    commentModal: false,
    addTicket: false,
    selectedVariant: 0,
  };
  componentDidMount() {
    this.getData();
  }

  addTicket = () => {
    this.setState({ addTicket: !this.state.addTicket });
  };
  getData = () => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    this.setState({ loading: true }, () => {
      const Headers = {
        Authorization: localStorage.getItem("Api_key") || token(),
        "content-type": "application/json",
      };
      axios
        .get(
          `${apiCall_domain}/customer/products/${this.props.match.params.id}${
            searchParams.variant_id !== 0
              ? `?variant_id=${searchParams.variant_id}`
              : ""
          }`,
          {
            headers: Headers,
          },
        )
        .then((res) => {
          const url = new URL(window.location.href);
          const searchParams = new URLSearchParams(url.search);
          let paramObj = {
            variant_id: 0,
          };
          for (const [key, value] of searchParams.entries()) {
            paramObj[key] = value;
          }
          const variant = res.data.data.variants.find(
            (v) =>
              v.id ===
              (paramObj?.variant_id ||
                res.data.data.min_price_variant.variant_id),
          );
          this.setState({
            data: res.data.data,
            loading: false,
            selectedVariant:
              +searchParams.get("variant_id") || variant?.id || 0,

            isFavorite: res.data.data.favorite,
            selectedVendor: res.data.data.vendors[0],
          });
        });
      this.getShoppingCart();
    });
  };
  getShoppingCart = () => {
    this.setState({ shoppingCart: {} }, () => {
      const Headers = {
        Authorization: localStorage.getItem("Api_key") || token(),
        "content-type": "application/json",
      };
      axios
        .get(`${apiCall_domain}/customer/shopping-cart`, {
          headers: Headers,
        })
        .then((res) => {
          const shoppingCart = { products: [], count: 0, price: 0 };
          res.data.data?.types?.forEach((type) => {
            if (type === 1) {
              shoppingCart.count += shoppingCart.count + type.items.length;
            } else {
              shoppingCart.count += shoppingCart.count + type.items.length;
            }
            shoppingCart.products.push(...type.items);
            for (const item of type.items) {
              shoppingCart.price += item.count * item.price;
              if (
                item.item_id == this.props.match.params.id &&
                !this.state.addedToCart
              ) {
                this.setState({ addedToCart: true });
              }
            }
          });
          if (shoppingCart.products.length) {
            this.setState({ shoppingCart });
          } else {
            this.setState({ addedToCart: false });
          }
        });
    });
  };
  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.getData();
    }
  }
  handleBodyOverflow = (state) => {
    const body = document.querySelector("body");
    if (state) {
      body.style.overflow = "hidden";
    } else {
      body.style.overflow = "auto";
    }
  };
  removeFromCart = (id) => {
    const config = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    return axios.post(
      `${apiCall_domain}/customer/shopping-cart/${id}?is_major=${0}`,
      {},
      { headers: config },
    );
  };

  addToCart = ({ count, itemId, installNeed }) => {
    const data = {
      count,
      item_id: itemId,
      install_need: installNeed,
    };
    const config = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    return axios.post(`${apiCall_domain}/customer/shopping-cart`, data, {
      headers: config,
    });
  };
  handleImageGallery = () => {
    this.setState({ showImageGallery: !this.state.showImageGallery });
  };
  handleVendorList = (state) => {
    this.setState({ showVendorList: state });
    this.handleBodyOverflow(state);
  };
  handleAddToCardModal = (state) => {
    this.setState({
      showAddToCartModal: state,
      showImageGallery: false,
      showVendorList: false,
    });
  };
  changeSelectedVendor = (vendor) => {
    this.setState({ selectedVendor: vendor });
  };

  handleAddFavorite = () => {
    const config = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/user/favorite/${this.state.data.id}`, {
        headers: config,
      })
      .then((res) => {
        this.setState({ isFavorite: true });
      });
  };
  handleRemoveFavorite = () => {
    const config = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .post(
        `${apiCall_domain}/customer/user/delete/favorite_item`,
        { item_id: this.state.data.id },
        { headers: config },
      )
      .then((res) => {
        this.setState({ isFavorite: false });
      });
  };
  modalToggler = () =>
    this.setState({ commentModal: !this.state.commentModal });

  render() {
    console.log(this.state.selectedVariant);
    const GlobalStyles = createGlobalStyle`body{
      background: #F9F9F9 !important;
    }`;
    const { brand, comments, category, avg_rate } = this.state.data || {};
    const { suitable_cars, frequently_questions } = this.state.data;
    return (
      <Product.Provider
        value={{
          selectedVariant: this.state.selectedVariant,
          product: this.state.data,
          addToCart: this.addToCart,
          addedToCart: this.state.addedToCart,
          removeFromCart: this.removeFromCart,
          selectedVendor: this.state.selectedVendor,
          shoppingCart: this.state.shoppingCart,
          getShoppingCart: this.getShoppingCart,
          handleAddToCardModal: this.handleAddToCardModal,
          changeSelectedVendor: this.changeSelectedVendor,
        }}
      >
        <>
          {this.state.loading ? (
            <Spinner />
          ) : !this.state.commentModal ? (
            <>
              {!this.state.showAddToCartModal &&
              !this.state.showVendorList &&
              !this.state.showImageGallery &&
              !this.state.addTicket ? (
                <Header
                  showSearchBar={true}
                  showBasket={true}
                  likeIcon={true}
                  filledIcon={this.state.isFavorite}
                  handleLike={
                    this.state.isFavorite
                      ? this.handleRemoveFavorite
                      : this.handleAddFavorite
                  }
                  shoppingCardCount={this.state.shoppingCart.count}
                />
              ) : null}
              <GlobalStyles />
              {this.state.showImageGallery ? (
                <PicturesTab
                  pics={this.state.data.pics}
                  comments={comments}
                  handleImageGallery={this.handleImageGallery}
                />
              ) : this.state.showVendorList ? (
                <OtherVendors
                  selectedVariant={this.state.selectedVariant}
                  vendors={this.state.data.vendors}
                  handleVendorList={this.handleVendorList}
                />
              ) : this.state.showAddToCartModal ? (
                <Service />
              ) : this.state.addTicket ? (
                <AddTicket
                  vendors={this.state.data.vendors}
                  addTicket={this.addTicket}
                />
              ) : (
                <div className="productComponent">
                  <ProductsInfo
                    product={this.state.data}
                    handleImageGallery={this.handleImageGallery}
                  />
                  <div className="brand">
                    <div>
                      <span className="Title">برند :</span>
                      <Link to={`/brands/${brand.id}`}>
                        <span className="Text">{brand?.name}</span>
                      </Link>
                    </div>
                    <div>
                      <span className="Title">دسته بندی :</span>
                      <span className="Text">{category}</span>
                    </div>
                  </div>
                  <div className="score">
                    <div className="avgRate">
                      <span>{avg_rate}</span>
                      <img src="/public/assets/pic.svg" alt="pic" />
                    </div>
                    <div className="ScoreComment">
                      <span className="Text">{comments.length} دیدگاه</span>
                      <span>برای این محصول ثبت شده </span>
                    </div>
                  </div>
                  {this.state.data.variants.length ? (
                    <>
                      <label>تنوع مورد نظر را انتخاب کنید</label>

                      <div className={"variantsList"}>
                        {[
                          { value: 0, label: "محصول اصلی" },
                          ...this?.state?.data?.variants?.map((car) => ({
                            value: car.id,
                            label: car.title,
                          })),
                        ].map((v) => (
                          <span
                            className={`${
                              this.state.selectedVariant === v.value
                                ? `selected`
                                : ""
                            }`}
                            onClick={() => {
                              this.setState(
                                {
                                  selectedVariant: v.value,
                                },
                                () => {
                                  const url = new URL(window.location.href);

                                  url.searchParams.set("variant_id", v.value);

                                  window.history.replaceState(
                                    {},
                                    "",
                                    url.toString(),
                                  );
                                  this.getData();
                                },
                              );
                            }}
                            key={v.value}
                          >
                            {v.label}
                          </span>
                        ))}
                      </div>
                    </>
                  ) : null}
                  {this.state.data.stock >=
                  (this.state.data.is_tire ? 2 : 1) ? (
                    <>
                      <Vendors
                        props={this.props}
                        data={this.state.data}
                        addToCart={this.addToCart}
                      />
                      <div
                        className="anotherVendors"
                        onClick={this.handleVendorList}
                      >
                        مشاهده لیست کامل فروشندگان (
                        {
                          this.state.data.vendors.filter(
                            (v) =>
                              v.variant_id ===
                              (this.state.selectedVariant !== 0
                                ? this.state.selectedVariant
                                : null),
                          ).length
                        }
                        )
                        <img
                          className="anotherVendorsNameLogo"
                          src="/public/assets/icons/store_1_.svg"
                          alt="pic"
                        />
                        <img
                          src="/public/assets/icons/anotherVendors.svg"
                          alt="فروشگاه"
                        />
                      </div>
                      <div className="anotherVendors" onClick={this.addTicket}>
                        ارتباط مستقیم با فروشنده
                        <img
                          className="anotherVendorsNameLogo"
                          src="/public/assets/icons/store_1_.svg"
                          alt="pic"
                        />
                        <img
                          src="/public/assets/icons/anotherVendors.svg"
                          alt="فروشگاه"
                        />
                      </div>
                      {/* <ReturnTerms
                                returnCondition={this.state.data.return_condition}
                              /> */}
                    </>
                  ) : (
                    <div className="outOfStockReason">
                      {this.state.data.stock <=
                      (this.state.data.is_tire ? 2 : 1)
                        ? "به دلیل عدم موجودی, فروشنده ای برای این محصول وجود ندارد"
                        : null}
                    </div>
                  )}
                  {this.state.data.features.length ? (
                    <>
                      <div className="Descriptionfeatures">
                        <div className="title">
                          <h3>توضیحات محصول </h3>
                        </div>
                        <div className="content">
                          {this.state.data.features.map((feature, index) => (
                            <div className="DescriptionPro" key={index}>
                              <div className="DescriptionText">
                                <span className="Title">
                                  {feature.feature} :
                                </span>
                                <span className="Text">{feature.value}</span>
                              </div>
                            </div>
                          ))}
                          <TotalDescription
                            features={this.state.data.features}
                            title={this.state.data.text}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="emptySection">
                      <span className="emptyText">
                        این محصول هیج توضیحاتی ندارد
                      </span>
                    </div>
                  )}
                  {/* show vendors list and return condition when porduct is not out of stock */}
                  {this.state.data.point_text ? (
                    <div className="anotherVendorsBuy">
                      <img src="/public/assets/star00.svg" alt="pic" />
                      <span className="Score">
                        {this.state.data.point_text}
                      </span>
                    </div>
                  ) : null}

                  {this.state.data.similar.length ? (
                    <SimilarProducts
                      similarProducts={this.state.data.similar}
                      stock={this.state.data.stock}
                      props={this.props}
                    />
                  ) : null}
                  <CommentProduct
                    vendor_item_id={this.state.selectedVendor?.vendor_item_id}
                    item_id={this.state.data.id}
                    comments={comments}
                    avg_rate={this.state.data.avg_rate}
                    data={this.state.data}
                    modalToggler={this.modalToggler}
                  />
                  {this.state.addedToCart ? (
                    <div className="multibasketDiv">
                      <div className="right">
                        <p className="orderCount">
                          {this.state.shoppingCart?.count} سفارش
                        </p>
                        <div>
                          <span>مبلغ کل :</span>
                          <span>
                            {this.state.shoppingCart?.price?.toLocaleString()}
                            &nbsp;
                          </span>
                          <span>تومان</span>
                        </div>
                      </div>
                      <div className="left">
                        <Link to={"/shoppingCart"}>تکمیل خرید</Link>
                      </div>
                    </div>
                  ) : null}
                  {this.state.data.blog.length ? (
                    <RelatedPosts blog={this.state.data.blog} />
                  ) : null}
                  <SuitableCars
                    data={{
                      suitable_cars: suitable_cars,
                      frequently_questions: frequently_questions,
                    }}
                  />
                </div>
              )}
            </>
          ) : (
            <CommentView
              vendor_item_id={this.state.selectedVendor?.vendor_item_id}
              item_id={this.state.data.id}
              comments={comments}
              avg_rate={this.state.data.avg_rate}
              modalToggler={this.modalToggler}
            />
          )}
        </>
      </Product.Provider>
    );
  }
}
export default Products;
